<div class="flex justify-center w-full md:mt-11 pb-8">
    <img src="assets/icons/Icons/other-payment-options/OTT-Voucher.png" alt="ott voucher logo">
</div>
<div class="w-full">
    <p class="my-6">Pay using an OTT voucher&#33;</p>
    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
        <b class="col-span-1">Step 1:</b>
        <p class="col-span-3 md:col-span-5">Purchase an OTT voucher at any of the supported retailers or online <a href="https://buyvoucher.ott-mobile.com/" target="_">here</a></p>
    </div>
    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
        <b class="col-span-1">Step 2:</b>
        <p class="col-span-3 md:col-span-5">Enter the voucher number and mobile number used to purchase the voucher</p>
    </div>
    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
        <b class="col-span-1">Step 3:</b>
        <p class="col-span-3 md:col-span-5">Click Pay and your transaction will be processed successfully</p>
    </div>
</div>